export default __webpack_public_path__ + "static/media/logo-cybersescgo.894f4dba.svg";